/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceDependencyRelationship extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceDependencyRelationship");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceDependencyRelationship.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceDependencyRelationship>): BackgroundJobPayloadForResourceDependencyRelationship {
        let obj = Object.assign(new BackgroundJobPayloadForResourceDependencyRelationship(), model);
        BackgroundJobPayloadForResourceDependencyRelationship.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceDependencyRelationship>): BackgroundJobPayloadForResourceDependencyRelationship {
        if (!model) return null;
        return BackgroundJobPayloadForResourceDependencyRelationship.newInstance(<BackgroundJobPayloadForResourceDependencyRelationship> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceDependencyRelationship) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceDependencyRelationship.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceDependencyRelationship): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceDependencyRelationship.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    dependency_type: models.ResourceDependencyRelationshipType;

}
